import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /var/www/vhosts/stas.dev.ergonized.com/httpdocs/angtest/angtest/src/app/app.component.ts